import classNames from "classnames";

import { useEffect, useState } from "react";
import { useTranslate } from "../../../../../../i18n/useTranslationModules";
import { useTypedSelector } from "../../../../../../store/reducers/use-typed-selector";
import { getDefaultAgendaImage } from "../../../../../../store/utils/create-event";
import { TemplateNames } from "../../../../../../types/template-layouts";
import { Session, SessionPreview } from "../../../../../../types/working-model";
import Checkbox from "../../../../../general-ui/checkbox/checkbox";
import { COLORS, ICONS } from "../../../../../general-ui/icon";
import { TypographyItem } from "../../../../../general-ui/typography-item/typography-item";

interface CarouselCardProps {
	track: string;
	index: number;
	toggleCard: (track: string, sessionId: number, enabled: boolean) => void;
	selected?: boolean,
	session: Session | SessionPreview;
}

const CarouselCard: React.FC<CarouselCardProps> = (({ track, index, toggleCard, session, selected = false }) => {

	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const template = workingEvent?.template.name || TemplateNames.Classic;
	const [cardSelected, setCardSelected] = useState(selected);

	useEffect(() => {
		setCardSelected(selected);
	}, [selected]);

	const handleSelectCard = () => {
		setCardSelected(prev => !prev);
		toggleCard(track, session.session, !cardSelected);
	};

	const { t } = useTranslate('homepage');

	return (
		<div key={`${track}-${index}`} className={classNames("ondemand-carousel-card", { "active": cardSelected })} onClick={handleSelectCard}>
			{session.image ? <img src={session.image} alt={"session image"} /> : <img src={getDefaultAgendaImage(template, index)} alt={"session image"} />}
			<TypographyItem
				className={classNames('agenda-session-card-title ondemand-carousel-card-title-content')}
				tagName="h4"
			>
				{t(`agenda.session.${session.session}.title`, session.title.base || '')}
			</TypographyItem>

			<div className="is-selected-icon">
				<Checkbox
					size={20}
					checked={cardSelected}
					value={session.title.base}
					onChange={handleSelectCard}
					selectedIconName={ICONS.SQUARE_CHECKBOX_SELECTED}
					unselectedIconName={ICONS.SQUARE_CHECKBOX_UNSELECTED}
					activeColor={COLORS.CYAN}
					transparent
				/>
			</div>
		</div>
	);
});


export default CarouselCard;